import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@hiring-intelligence/ui';
import { useAuthStore } from '@/stores/auth';
import Layout from '@/components/layout/Layout';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import HiringRequestPage from '@/pages/HiringRequest/HiringRequestPage';
import HiringRequestDetailPage from '@/pages/HiringRequest/HiringRequestDetailPage';
import JDGeneratorPage from '@/pages/JDGenerator/JDGeneratorPage';
import JobDescriptionsPage from '@/pages/JobDescriptions/JobDescriptionsPage';
import CompaniesPage from '@/pages/Companies/CompaniesPage';
import CompanyDetailPage from '@/pages/Companies/CompanyDetailPage';
import CandidatesPage from '@/pages/Candidates/CandidatesPage';
import CandidateDetailPage from '@/pages/Candidates/CandidateDetailPage';
import DealsPage from '@/pages/CRM/DealsPage';
import DealDetailPage from '@/pages/CRM/DealDetailPage';
import ContactsPage from '@/pages/CRM/ContactsPage';
import ContactDetailPage from '@/pages/CRM/ContactDetailPage';
import UsersPage from '@/pages/UsersPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	return <>{children}</>;
}

export default function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/login" element={<LoginPage />} />

				<Route
					path="/"
					element={
						<ProtectedRoute>
							<Layout />
						</ProtectedRoute>
					}
				>
					<Route index element={<DashboardPage />} />
					<Route path="dashboard" element={<DashboardPage />} />
					<Route path="hiring-requests" element={<HiringRequestPage />} />
					<Route path="hiring-requests/:id" element={<HiringRequestDetailPage />} />
					<Route path="job-descriptions" element={<JobDescriptionsPage />} />
					<Route path="job-descriptions/:id" element={<JDGeneratorPage />} />
					<Route path="companies" element={<CompaniesPage />} />
					<Route path="companies/:id" element={<CompanyDetailPage />} />
					<Route path="deals" element={<DealsPage />} />
					<Route path="deals/:id" element={<DealDetailPage />} />
					<Route path="contacts" element={<ContactsPage />} />
					<Route path="contacts/:id" element={<ContactDetailPage />} />
					<Route path="candidates" element={<CandidatesPage />} />
					<Route path="candidates/:id" element={<CandidateDetailPage />} />
					<Route path="users" element={<UsersPage />} />
				</Route>

				{/* Redirect /dashboard to / for authenticated users */}
				<Route path="/dashboard" element={
					<ProtectedRoute>
						<Navigate to="/" replace />
					</ProtectedRoute>
				} />
			</Routes>
			<Toaster />
		</BrowserRouter>
	);
}
